import { createRouter, createWebHashHistory } from "vue-router";
import Layout from "@/layout";

const routes = [
  {
    path: "/",
    component: Layout,
    redirect: "/index",
  },
  {
    path: "/index",
    component: Layout,
    children: [
      {
        path: "/index",
        name: "ali_movingFunction",
        component: () => import("@/views/moving_function"),
        meta: {
          title: "1688分销铺货",
          img: "https://static.zzbtool.com/static/dyorder/1688-icon.png",
          hide: true,
        },
      },
    ],
  },
  {
    path: "/order_before",
    component: Layout,
    redirect: "/order_before",
    meta: {
      title: "订单管理",
      icon: "quill-pen-line",
    },
    children: [
      {
        path: "/order_before",
        name: "orderBefore",
        component: () => import("@/views/order_before"),
        meta: {
          title: "订单管理",
          icon: "quill-pen-line",
        },
      },
    ],
  },
  // {
  //   path: '/home/order_after',
  //   component: Layout,
  //   meta: {
  //     title: '售后管理',
  //     icon: 'alarm-warning-line',
  //   },
  //   children: [
  //     {
  //       path: '/home/order_after',
  //       name: 'after_order',
  //       component: () => import('@/views/order_after'),
  //       meta: {
  //         title: '售后管理',
  //         icon: 'alarm-warning-line',
  //       },
  //     },
  //   ],
  // },
  {
    path: "/home/shot_list",
    component: Layout,
    meta: {
      title: "拍单列表",
      icon: "file-list-line",
    },
    children: [
      {
        path: "/home/shot_list",
        name: "shot_list",
        component: () => import("@/views/shot_list"),
        meta: {
          title: "拍单列表",
          icon: "file-list-line",
        },
      },
    ],
  },
  {
    path: "/home/order_remark_template",
    component: Layout,
    redirect: "/home/order_remark_template",
    meta: {
      title: "订单设置",
      icon: "alarm-warning-line",
    },
    children: [
      {
        path: "/home/order_remark_template",
        name: "order_remark_template",
        component: () => import("@/views/order_remark_template"),
        meta: {
          title: "订单设置",
          icon: "alarm-warning-line",
        },
      },
    ],
  },
  {
    path: "/home/mallGroup",
    component: Layout,
    meta: {
      title: "店铺管理",
      icon: "team-line",
    },
    children: [
      {
        path: "/home/mallGroup",
        name: "mallGroup",
        component: () => import("@/views/mall_group"),
        meta: {
          title: "店铺管理",
          icon: "team-line",
        },
      },
    ],
  },
  {
    path: "/home/goodManage",
    component: Layout,
    meta: {
      title: "私域商品管理",
      icon: "team-line",
    },
    children: [
      {
        path: "/home/goodManage",
        name: "goodManage",
        component: () => import("@/views/good_manage"),
        meta: {
          title: "私域商品管理",
          img: "https://static.zzbtool.com/static/pdd/pdd_menu_car.png",
        },
      },
    ],
  },
  {
    path: "/gotoUrl",
    component: Layout,
    meta: {
      title: "商家后台",
      icon: "team-line",
      url: "https://saas.isaas.com/?productId=sas-230710JsMxnatNEm4juH95Ftg4A9&bpToken=4ed72234ee554fdba2980cc33d8ab3a5&tenantId=tnt-230912CDiBKhb8C48PB3Gy2sLT3m",
    },
    children: [],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
